import { render } from "./LandingPageHS.vue?vue&type=template&id=47c57b34&scoped=true"
import script from "./LandingPageHS.vue?vue&type=script&lang=js"
export * from "./LandingPageHS.vue?vue&type=script&lang=js"

import "./LandingPageHS.vue?vue&type=style&index=0&id=47c57b34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c57b34"]])

export default __exports__